import * as PostAction from './post.actions';
import {Post} from '../post.model';

export interface State {
  audits: Post[];
  audit: Post;
  chartReload: string;
  postDetail: any;
  postProgress: any;
  audienceStat: any;
  followerStat: any;
  mediaStat: any;
  audienceInterest: any;
  audienceLocation: any;
  loader: any;
}

const initialState: State = {
  audits: [],
  audit: null,
  chartReload: '',
  postDetail: null,
  postProgress: null,
  audienceStat: null,
  followerStat: null,
  mediaStat: null,
  audienceInterest: null,
  audienceLocation: null,
  loader: {
    auditList: {
      list: true
    },
    audit: {
      detail: true,
      followerStat: true,
      mediaStat: true,
      audienceStat: true,
      audienceLocation: true,
      export: true
    }
  }
};

export function postReducer(state = initialState, action: PostAction.PostActions) {
  switch (action.type) {
    case PostAction.SET_AUDIT:
      return {
        ...state,
        audit: action.payload
      };
    case PostAction.SET_AUDITS:
      return {
        ...state,
        audits: action.payload
      };
    case PostAction.SET_POST_DETAIL:
      return {
        ...state,
        postDetail: action.payload
      };
    case PostAction.SET_LOADER:
      const loader = state.loader;
      loader[action.payload.module][action.payload.box] = action.payload.value;
      return {
        ...state,
        loader: loader
      };
  }

  return state;
}
